import type { SaveBarIconProps } from "./save-bar-icon.type";

import { CarryOutOutlined, WarningOutlined } from "@ant-design/icons";

import { SAVE_BAR_STATUS } from "@/ui/save-bar";

export const SaveBarIcon = ({ status }: SaveBarIconProps) => {
  if (status === SAVE_BAR_STATUS.SUCCESS) {
    return <CarryOutOutlined className="save-bar-icon success" />;
  }

  if (status === SAVE_BAR_STATUS.WARNING) {
    return <WarningOutlined className="save-bar-icon warning" />;
  }

  return null;
};
